import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/ReceiveWax.css";

export default function CompletedWax() {
  const [lots, setLots] = useState([]);
  const [castingDate, setCastingDate] = useState({});

  useEffect(() => {
    fetchCompletedLots();
  }, []);

  // ===========================================================
  // FETCH COMPLETED LOTS (WORKS WITH YOUR DB)
  // ===========================================================
  const fetchCompletedLots = async () => {
    const { data: lotsData, error: lotsErr } = await supabase
      .from("WAX_LOTS")
      .select("id, lot_no, worker_id, issue_date, status")
      .in("status", ["COMPLETED", "COMPLETED_WAX"])
      .order("issue_date", { ascending: false });

    if (lotsErr) {
      console.error("Lots error:", lotsErr);
      return;
    }

    if (!lotsData?.length) {
      setLots([]);
      return;
    }

    const lotIds = lotsData.map((l) => l.id);

    // ===========================================================
    // FIXED ITEMS QUERY (NO casting_done)
    // ===========================================================
    const { data: items, error: itemsErr } = await supabase
      .from("WAX_ITEMS")
      .select(`
        id,
        lot_id,
        item_id,
        design_code,
        gross_weight,
        net_weight,
        pieces_count,
        ITEMS:item_id ( item_name )
      `)
      .in("lot_id", lotIds);

    if (itemsErr) {
      console.error("Items error:", itemsErr);
      return;
    }

    // group items under their lots
    const merged = lotsData.map((lot) => ({
      ...lot,
      items: items.filter((i) => i.lot_id === lot.id),
    }));

    setLots(merged);
  };

  // ===========================================================
  // SAVE CASTING DONE (remove casting_done updates)
  // ===========================================================
  const saveCastingDoneDirect = async (lot, item, dateValue) => {
    if (!dateValue) {
      alert("Please select a date.");
      return;
    }

    // Calculate gain/loss using actual DB fields
    const issued = Number(item.gross_weight || 0);
    const received = Number(item.net_weight || 0);
    const gainLoss = received - issued;

    const { error } = await supabase.from("casting_done").insert({
      lot_id: lot.id,
      lot_no: lot.lot_no,
      item_id: item.item_id,
      wax_item_id: item.id,
      gain_loss: gainLoss,
      casting_date: dateValue,
    });

    if (error) {
      console.error(error);
      alert("Error moving to casting");
      return;
    }

    alert("Moved to Casting!");
    fetchCompletedLots();
  };

  // ===========================================================
  // UI
  // ===========================================================
  return (
    <div className="receive-container">
      <h2 className="page-title">Completed Wax Lots</h2>

      {lots.length === 0 && <p>No completed lots.</p>}

      {lots.map((lot) => {
        const totalGainLoss = lot.items.reduce((sum, it) => {
          const issued = Number(it.gross_weight || 0);
          const received = Number(it.net_weight || 0);
          return sum + (received - issued);
        }, 0);

        return (
          <div className="lot-card" key={lot.id}>
            <div className="lot-header">
              <h3>{lot.lot_no}</h3>
              <p>Date: {lot.issue_date?.slice(0, 10)}</p>
              <p>
                <b>Total Gain/Loss: </b>
                <span style={{ color: totalGainLoss >= 0 ? "green" : "red" }}>
                  {totalGainLoss.toFixed(3)}
                </span>
              </p>
            </div>

            <table className="wax-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Design</th>
                  <th>Issued Gross</th>
                  <th>Received Net</th>
                  <th>Gain/Loss</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {lot.items.map((it) => {
                  const issued = Number(it.gross_weight || 0);
                  const received = Number(it.net_weight || 0);
                  const gainLoss = received - issued;

                  return (
                    <tr key={it.id}>
                      <td>{it.ITEMS?.item_name}</td>
                      <td>{it.design_code}</td>
                      <td>{issued}</td>
                      <td>{received}</td>
                      <td
                        style={{
                          color: gainLoss >= 0 ? "green" : "red",
                          fontWeight: "bold",
                        }}
                      >
                        {gainLoss.toFixed(3)}
                      </td>
                      <td style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <input
                          type="date"
                          value={castingDate[it.id] || ""}
                          onChange={(e) =>
                            setCastingDate((prev) => ({
                              ...prev,
                              [it.id]: e.target.value,
                            }))
                          }
                        />

                        <button
                          className="wax-btn"
                          onClick={() => saveCastingDoneDirect(lot, it, castingDate[it.id])}
                        >
                          Move to Casting
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
